import { Prospector } from '@clearkit/icons';
import classNames from 'classnames';
import { CKTooltip } from 'clearkit';

import { trackEvent } from '~/lib/tracking';

const ProspectorButton = ({
  domain,
  name,
  loading,
  type,
}: {
  domain: string;
  name?: string;
  loading: boolean;
  type: 'visitors' | 'target_markets';
}) => {
  const displayName = name || domain;

  return (
    <CKTooltip
      hasHover={!loading}
      placement="bottom"
      tooltip={`Find prospects at ${displayName}`}
      tooltipMaxWidth="240px"
    >
      <a
        className={classNames(
          'text-gray-600 hover:text-blue py-1.5 px-2 rounded hover:bg-gray-50 transition-colors duration-200 ck-box',
          {
            'ck-skeleton': loading,
            'bg-white': !loading,
          },
        )}
        href={`/prospector?new=true&source=${type}&domain=${domain}`}
        onClick={(e) => {
          e.stopPropagation();

          trackEvent(
            type === 'target_markets'
              ? 'target_markets_prospector_opened'
              : 'visitor_report_prospector_opened',
            {
              domain,
              type: 'single',
            },
          );
        }}
        target={'_blank'}
      >
        <Prospector className="w-[18px] h-[18px] 2xl:w-5 2xl:h-5" />
      </a>
    </CKTooltip>
  );
};

export default ProspectorButton;
